/* global dataLayer */
/* global fbq */

/*
----------------------------------------------------------------------------
Usage:
----------------------------------------------------------------------------
import FormValidate from './modules/form-validate'
_('', 'validate').nodes().map((el) => new FormValidate(el))
*/
import { _ } from './../utils'
import { makeGtmCall } from './../tracking'
import Validate from '../modules/validate'
import loading from '../templates/loading'

export default class FormValidate {
    constructor(el) {
        this.form = el
        this.form.dataset.validated = 'false'
        this.showSummary = this.form.dataset.summary === 'true' ?? false
        this.summaryBox = _('summary', 'element').nodeFrom(this.form)
        this.pristine = new Validate(this.form)
        this.form.addEventListener('submit', this.formSubmit)
        this.checkboxChanger = _('reveal-checkbox').nodesFrom(this.form)
        this.restartTrigger = _('restart-validation').node()
        this.formErrorMessage = this.form.dataset.error

        if (this.checkboxChanger) {
            this.checkboxChanger.forEach((checkbox) => {
                checkbox.addEventListener('change', this.restartPristine)
            })
        }
        this.restartTrigger?.addEventListener('input', this.restartPristine)
        this.loadingContainer = _('target-loading-container', 'element').nodeFrom(this.form)
    }

    restartPristine = () => {
        setTimeout(() => {
            if (this.form.dataset.validated === 'false') {
                this.pristine = new Validate(this.form)
            }
            if (this.form.dataset.validated === 'failed') {
                this.pristine = new Validate(this.form)
                this.pristine.validate()
            }
        }, 100)
    }

    formSubmit = (e) => {
        if (this.loadingContainer) {
            this.loadingContainer.innerHTML = loading('loader--whiteout')
        }

        const shippingCountyInput = document.querySelector('#shipping-county')
        const billingCountyInput = document.querySelector('#billing-county')
        if (shippingCountyInput && !document.querySelector('#address-choice-new')?.checked) {
            shippingCountyInput.removeAttribute('data-required')
            shippingCountyInput.required = false
        }
        if (billingCountyInput && !document.querySelector('#billing-address-choice-new')?.checked) {
            billingCountyInput.removeAttribute('data-required')
            billingCountyInput.required = false
        }

        const valid = this.pristine.validate()

        if (!valid && this.showSummary) {
            if (this.loadingContainer) {
                this.loadingContainer.innerHTML = ''
            }
            window.scrollTo(0, 0)
            this.summaryBox.classList.remove('u-hidden')
            const errors = this.pristine.getErrors()
            let markup = `<div class="u-weight-regular"><p class="u-size-default u-color-tundora">${this.formErrorMessage}</p><div class="wysiwyg"><ul>`
            errors.forEach((error) => {
                const radioName = error.input.name
                if (error.input.type === 'radio' && markup.includes(radioName)) {
                    return false
                }
                const labelText = document.querySelector(`[for="${error.input.id}"]`)

                if (!labelText) {
                    console.warn('missing:', error.input)
                    return false
                }
                const errorMessage = error.input.dataset.errorMessage ?? labelText.innerText

                markup += `<li><a href="#${error.input.id}" class="link u-size-default u-weight-regular" data-name="${radioName}">${errorMessage}</a></li>`
            })
            markup += '</ul></div></div>'
            this.summaryBox.innerHTML = markup
        }

        if (!valid) {
            this.form.dataset.validated = 'failed'
            e.stopImmediatePropagation()
            e.preventDefault()

            const firstErrorField = this.form.querySelector('.form__error')
            let firstErrorFieldPosition = 0
            if (firstErrorField) {
                firstErrorFieldPosition = firstErrorField.offsetTop
            }
            window.scrollTo({
                top: firstErrorFieldPosition,
                left: 0,
                behavior: 'smooth'
            })
        }
        if (valid) {
            this.form.dataset.validated = 'true'
            makeGtmCall(this.form)
        }
    }
}
